import React from 'react';
import ConnectionSideUser from './ConnectionSideUser/ConnectionSideUser';
import ConnectionSideSelf from './ConnectionSideSelf/ConnectionSideSelf';
import StartNetworking from './StartNetworking/StartNetworking';

function ConnectionSide(props) {
    const {eventId, self, user, startNetworking, title=true, baseRoute, onShowAvatarModal} = props;

    if (user) {
        return <ConnectionSideUser user={user} baseRoute={baseRoute} onShowAvatarModal={onShowAvatarModal} />;
    } else if (self) {
        return <ConnectionSideSelf baseRoute={baseRoute} />;
    } else if (startNetworking) {
        return <StartNetworking eventId={eventId} title={title} />;
    }

    return null;
}

export default ConnectionSide;
